// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CudQ","rootMobile":"styles_rootMobile__1sid0"};